import React from 'react'
import Company from 'components/Company'

export default Component => props => (
  <Company
    render={({ company }) => <Component company={company} {...props} />}
  />
)



// WEBPACK FOOTER //
// ./src/components/withCompany.js